"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalProductCard = void 0;
const card_1 = require("../card/card");
const utils_1 = require("../../../utils/utils");
const key_1 = require("../../../utils/key");
const QUICK_VIEW_BUTTON_SELECTOR = '[data-product-card-quick-view-button]';
const QUICK_VIEW_SELECTOR = '#Quick-view';
const VARIANT_CHOOSE_BUTTONS_SELECTOR = "[data-product-card-variant-selection]";
const VARIANT_PICKER_DRAWER_TOGGLES_SELECTOR = '[data-toggle-variant-picker-drawer]';
class VerticalProductCard extends card_1.Card {
    mountComponent() {
        const quickViewBtn = (0, utils_1.$el)(QUICK_VIEW_BUTTON_SELECTOR, this);
        const variantChooseButtons = (0, utils_1.$list)(VARIANT_CHOOSE_BUTTONS_SELECTOR, this);
        const variantPickerDrawerToggles = (0, utils_1.$list)(VARIANT_PICKER_DRAWER_TOGGLES_SELECTOR, this);
        this.addListener(quickViewBtn, 'click', this.handleQuickViewBtnClick);
        this.addListener(quickViewBtn, 'keydown', this.handleQuickViewBtnKeyDown);
        this.addListener(this, 'mouseenter', this.handleProductCardEnter);
        variantChooseButtons.forEach(variantChooseButton => this.addListener(variantChooseButton, 'click', () => {
            this.handleVariantBtnClick(variantChooseButton);
        }));
        variantPickerDrawerToggles.forEach(variantPickerDrawerToggle => this.addListener(variantPickerDrawerToggle, 'click', () => {
            this.toggleVariantPickerDrawer(variantPickerDrawerToggle);
        }));
    }
    handleQuickViewBtnKeyDown = async (event) => {
        if ((0, key_1.isEnterKey)(event)) {
            event.preventDefault();
            this.callQuickView(true);
        }
    };
    handleQuickViewBtnClick = async () => {
        this.callQuickView(true);
    };
    handleProductCardEnter = () => {
        this.callQuickView(false);
    };
    async callQuickView(withOpen) {
        const quickView = (0, utils_1.$el)(QUICK_VIEW_SELECTOR);
        const url = this.dataset.url;
        const id = this.dataset.id;
        if (!quickView || !url || !id) {
            return;
        }
        await quickView.requestProductFromUrl(url, id);
        if (withOpen) {
            this.setQuickViewLoading(true);
            await quickView.openAndRenderProductByUrl(url);
            this.setQuickViewLoading(false);
        }
    }
    setQuickViewLoading(isLoading) {
        const quickViewBtn = (0, utils_1.$el)(QUICK_VIEW_BUTTON_SELECTOR, this);
        if (quickViewBtn) {
            quickViewBtn.classList.toggle('loading', isLoading);
            quickViewBtn.toggleAttribute('disabled', isLoading);
        }
    }
    handleVariantBtnClick = (variantChooseButton) => {
        const inputRelated = (0, utils_1.$el)(`input#${variantChooseButton.getAttribute('for')}`, this);
        inputRelated?.click();
        const variantId = inputRelated?.getAttribute('value');
        if (!variantId)
            return;
        const form = (0, utils_1.$el)('form#' + variantChooseButton.dataset.productFormId, this);
        if (!form)
            return;
        form.dispatchEvent(new CustomEvent('lbc-submit', { bubbles: true, detail: { button: variantChooseButton } }));
    };
    async updateVariantPickerDrawer(btn) {
        const productUrl = btn.getAttribute('data-product-url');
        await fetch(productUrl + "?section=variant-picker-drawer")
            .then(response => response.text())
            .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            let variantPickerDrawerInMainHTML = document.querySelector('.variant-picker-drawer');
            if (variantPickerDrawerInMainHTML) {
                const headerTitle = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__header-title');
                const content = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content');
                headerTitle.innerHTML = doc.querySelector('.variant-picker-drawer__header-title').innerHTML;
                content.innerHTML = doc.querySelector('.variant-picker-drawer__content').innerHTML;
            }
            else {
                document.body.insertAdjacentHTML('beforeend', doc.body.innerHTML);
            }
            variantPickerDrawerInMainHTML = document.querySelector('.variant-picker-drawer');
            const variantPickerDrawerToggles = variantPickerDrawerInMainHTML.querySelectorAll('[data-toggle-variant-picker-drawer]:not([data-toggle-variant-picker-drawer-initialized]');
            variantPickerDrawerToggles.forEach((toggle) => {
                toggle.setAttribute('data-toggle-variant-picker-drawer-initialized', '');
                toggle.addEventListener('click', () => {
                    this.toggleVariantPickerDrawer(toggle);
                });
            });
            const variantPickerDrawerOverlayInMainHTML = document.querySelector('.variant-picker-drawer__overlay:not([data-toggle-variant-picker-drawer-initialized]');
            if (variantPickerDrawerOverlayInMainHTML) {
                variantPickerDrawerOverlayInMainHTML.setAttribute('data-toggle-variant-picker-drawer-initialized', '');
                variantPickerDrawerOverlayInMainHTML.addEventListener('click', () => {
                    this.toggleVariantPickerDrawer(variantPickerDrawerOverlayInMainHTML);
                });
            }
            const variantPickerDrawerButtons = variantPickerDrawerInMainHTML.querySelectorAll('[data-product-card-variant-selection]');
            variantPickerDrawerButtons.forEach((variantPickerDrawerButton) => variantPickerDrawerButton.addEventListener('click', () => {
                this.handleVariantBtnClick(variantPickerDrawerButton);
            }));
            const variantPickerDrawerContent = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content');
            const variantPickerDrawerContentInner = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content__inner');
            // Check if the variant picker drawer content has overflow
            if (variantPickerDrawerContentInner.scrollHeight > variantPickerDrawerContentInner.clientHeight) {
                variantPickerDrawerContent.classList.add('variant-picker-drawer__content--with-overflow');
            }
            if (variantPickerDrawerContentInner) {
                variantPickerDrawerContentInner.addEventListener('scroll', () => {
                    if (variantPickerDrawerContentInner.scrollHeight - variantPickerDrawerContentInner.scrollTop === variantPickerDrawerContentInner.clientHeight) {
                        variantPickerDrawerContent.classList.remove('variant-picker-drawer__content--with-overflow');
                    }
                    else {
                        variantPickerDrawerContent.classList.add('variant-picker-drawer__content--with-overflow');
                    }
                });
            }
        });
    }
    async toggleVariantPickerDrawer(btn) {
        const uploadDrawer = btn.hasAttribute('data-update-variant-picker-drawer');
        if (btn.hasAttribute('data-btn-load-on-click')) {
            btn.classList.add("loading");
        }
        if (uploadDrawer) {
            await this.updateVariantPickerDrawer(btn);
        }
        const variantPickerDrawer = document.querySelector('.variant-picker-drawer');
        const variantPickerDrawerOverlay = document.querySelector('.variant-picker-drawer__overlay');
        if (variantPickerDrawer) {
            variantPickerDrawer.classList.toggle('variant-picker-drawer--open');
        }
        if (variantPickerDrawerOverlay) {
            variantPickerDrawerOverlay.classList.toggle('variant-picker-drawer__overlay--open');
        }
        if (btn.hasAttribute('data-btn-load-on-click')) {
            btn.classList.remove("loading");
        }
    }
}
exports.VerticalProductCard = VerticalProductCard;
